module.exports = __webpack_public_path__ + "img/full-fredos-1.34649421.jpg";